import React, { useState, useEffect } from 'react';

/**
 * RtfMemo component: converteert RTF naar HTML via het backend-endpoint
 * en geeft het resultaat weer, waarbij de HTML met dangerouslySetInnerHTML wordt gerenderd.
 */
function RtfMemo({ rtfText, style }) {
  const [htmlContent, setHtmlContent] = useState('');

  useEffect(() => {
    async function convertRtf() {
      if (rtfText) {
        try {
          const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/convert_rtf`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ rtf_text: rtfText })
          });
          const result = await response.json();
          if (result.html) {
            setHtmlContent(result.html);
          } else if (result.error) {
            console.error('Error converting RTF on server:', result.error);
            setHtmlContent('[Conversion error]');
          }
        } catch (error) {
          console.error('Error converting RTF:', error);
          setHtmlContent('[Conversion error]');
        }
      }
    }
    convertRtf();
  }, [rtfText]);

  return <div style={style} dangerouslySetInnerHTML={{ __html: htmlContent }} />;
}

/**
 * Converteert een YouTube URL naar de embed-versie.
 */
function convertYoutubeURLtoEmbed(url) {
  if (!url) return '';
  if (url.includes('youtube.com/watch?v=')) {
    return url.replace('watch?v=', 'embed/');
  }
  return url;
}

/**
 * Bepaalt de video URL op basis van een veld en de formData.
 */
function getVideoUrl(fld, formData) {
  if (fld.field && formData[fld.field] && formData[fld.field].trim() !== '') {
    return formData[fld.field];
  }
  return fld.url || '';
}


/**
 * Zet flat array om in nested tree. 
 * - flatData: array met objecten, met minimaal:
 *     PK_R_ASSEMBLYALLDETAIL (uniek),
 *     PARENT_ASSEMBLY_ID (int),
 *     CHILD_ASSEMBLY_ID (int of null),
 *     plus alle kolommen die je in de tree wilt tonen.
 * - rootId: de recordId (de PK_R_ASSEMBLY van de bovenste assembly).
 */
function buildTreeData(flatData, rootId) {
  // 1. Maak id→node map
  const idToNode = {};
  flatData.forEach(item => {
    idToNode[item.PK_R_ASSEMBLYALLDETAIL] = {
      key: String(item.PK_R_ASSEMBLYALLDETAIL), // unieker key voor rc-tree
      data: item,
      children: []
    };
  });

  // 2. Verbind parent → children
  flatData.forEach(item => {
    const myNode = idToNode[item.PK_R_ASSEMBLYALLDETAIL];
    const childAsm = item.CHILD_ASSEMBLY_ID;
    if (childAsm != null) {
      // Alle records waarvan PARENT_ASSEMBLY_ID === childAsm worden kinderen
      flatData
        .filter(r => r.PARENT_ASSEMBLY_ID === childAsm)
        .forEach(childRow => {
          myNode.children.push(idToNode[childRow.PK_R_ASSEMBLYALLDETAIL]);
        });
    }
  });

  // 3. Vind root-nodes: die met PARENT_ASSEMBLY_ID === rootId
  const roots = flatData
    .filter(item => item.PARENT_ASSEMBLY_ID === rootId)
    .map(item => idToNode[item.PK_R_ASSEMBLYALLDETAIL]);

  return roots;
}


export default RtfMemo;
export { convertYoutubeURLtoEmbed, getVideoUrl, buildTreeData };
